import React, { useContext } from 'react'
import styled from '@emotion/styled'
import { AppContext } from 'src/state/AppState'

import { Link as GatsbyLink } from 'gatsby'
import { AnchorLink } from 'gatsby-plugin-anchor-links'

const LinkStyles = setTheme => `
	font-size: inherit;
	text-decoration: none;
	cursor: pointer;
`

const StyledLinkElement = styled.div`
	${ ({ setTheme }) => `
		${ LinkStyles(setTheme) }
	` }
`

const StyledGatsbyLink = styled.div`
	${ ({ theme }) => `
		${ LinkStyles(theme) }
	` }
`

const Link = ({ to, external, target, children, label, className, setTheme, title, name, as, onClick, pageTransition = 'fade' }) => {
	const { setPageTransition } = useContext(AppContext)
	if (!external && to?.includes('#')) {
		as = AnchorLink
	}

	if (external) {
		return (
			<StyledLinkElement
				title={title}
				name={name || title}
				aria-label={name || title}
				className={className}
				href={to}
				target={target}
				theme={setTheme}
				rel='noopener noreferrer'
				onClick={onClick}
				as={as || 'a'}
			>
				{children || label}
			</StyledLinkElement>
		)
	} else {
		return (
			<StyledGatsbyLink
				title={title}
				name={name || title}
				aria-label={name || title}
				className={className}
				to={to}
				theme={setTheme}
				onClick={e => {
					setPageTransition(pageTransition)
					onClick && onClick(e)
				}}
				as={as || GatsbyLink}
				striphash
			>
				{children || label}
			</StyledGatsbyLink>
		)
	}
}

Link.defaultProps = {
	to: '#',
	external: false,
	target: '',
	setTheme: 'alert'
}

export default Link
